import { render, staticRenderFns } from "./BookmarkItem.vue?vue&type=template&id=98e4a07e"
import script from "./BookmarkItem.vue?vue&type=script&lang=js"
export * from "./BookmarkItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports